import React, { useState, useEffect } from 'react';

const EmpathyScrollStory = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const storySteps = [
    {
      icon: "fa-solid fa-cloud-arrow-up",
      title: "You bought the CRM everyone recommended.",
      subtitle: "The Promise",
      content: (
        <>
          <p>The demo was slick. The promises were big.</p>
          <p className="story-quote">"This will transform your sales process," they said.</p>
        </>
      )
    },
    {
      icon: "fa-solid fa-triangle-exclamation",
      title: "But three months later?",
      subtitle: "The Reality",
      content: (
        <ul className="story-reality-list">
          <li><i className="fa-solid fa-file-excel"></i> Your team is still using Excel.</li>
          <li><i className="fa-brands fa-whatsapp"></i> WhatsApp for quick updates.</li>
          <li><i className="fa-solid fa-note-sticky"></i> Sticky notes on monitors.</li>
          <li><i className="fa-solid fa-ban"></i> And that expensive CRM? It's the system everyone avoids.</li>
        </ul>
      )
    },
    {
      icon: "fa-solid fa-money-bill-trend-up",
      title: "Every new team member = another $50/month.",
      subtitle: "The Cost",
      content: (
        <>
          <p className="story-pain">Every feature request = "That's not available in your plan."</p>
          <p className="story-pain">Every integration = another plugin, another fee, another headache.</p>
          <p><strong>Your business is unique—but your CRM treats you like everyone else.</strong></p>
        </>
      )
    },
    {
      icon: "fa-solid fa-link-slash",
      title: "So you adapt.",
      subtitle: "The Compromise",
      content: (
        <>
          <ul className="story-compromise-list">
            <li>You bend your process to fit the software.</li>
            <li>You pay for 100 features and use 5.</li>
            <li>You train every new hire for days on a system they'll resent using.</li>
          </ul>
          <p style={{ marginTop: '16px' }}>And the data? It's there. Somewhere. Buried in dashboards no one trusts.</p>
        </>
      )
    }
  ];

  // Calculate wrapper width - always separated
  const cardWidth = isMobile ? 240 : 280;
  const spacing = 20;
  const wrapperWidth = storySteps.length * cardWidth + (storySteps.length - 1) * spacing;

  return (
    <section className="empathy-slider-section">
      <div className="empathy-slider-header">
        <h2>You're Not Alone in This</h2>
        <p className="header-subtitle">Are you paying for a CRM or just renting someone else's vision?</p>
      </div>

      <div className="empathy-slider-container">
        <div
          className="empathy-cards-wrapper"
          style={{
            width: `${wrapperWidth}px`
          }}
        >
          {storySteps.map((step, index) => {
            // Cards are always side by side
            const offset = index * (cardWidth + spacing);
            const zIndex = storySteps.length - index;

            return (
              <article
                key={index}
                className="empathy-slider-card"
                style={{
                  transform: `translateX(${offset}px)`,
                  zIndex
                }}
              >
                <figure className="empathy-card-icon-container">
                  <i className={`${step.icon} empathy-hero-icon`}></i>
                  <span className="card-tag">{step.subtitle}</span>
                </figure>

                <div className="empathy-card-content">
                  <h3 className="empathy-card-title">{step.title}</h3>

                  <div className="empathy-card-body">
                    {step.content}
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>

      {/* The Truth Section */}
      <div className="empathy-truth-section">
        <h3 className="truth-heading">
          <span className="truth-icon">💡</span>
          Here's the truth most vendors won't tell you:
        </h3>
        <p className="truth-statement">
          Most CRMs were built to <strong>sell subscriptions</strong>, not <strong>solve problems</strong>.
        </p>
      </div>
    </section>
  );
};

export default EmpathyScrollStory;
